<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Filter Form =========== -->
      <div
        class="filter_content_wrapper"
        :class="{ active: filterFormIsActive }"
      >
        <button
          class="filter_toggler"
          @click="filterFormIsActive = !filterFormIsActive"
        >
          <i class="fal fa-times"></i>
        </button>
        <div class="filter_title_wrapper">
          <h5>{{ $t("TITLES.searchBy") }}</h5>
        </div>
        <div class="filter_form_wrapper">
          <form @submit.prevent="submitFilterForm">
            <div class="row justify-content-center align-items-center w-100">
              <base-input
                col="3"
                type="text"
                :placeholder="$t('PLACEHOLDERS.name_admin')"
                v-model="filterOptions.provider"
              />

              <base-input
                col="3"
                type="text"
                :placeholder="$t('PLACEHOLDERS.clientName')"
                v-model="filterOptions.user"
              />

              <base-input
                col="3"
                type="text"
                :placeholder="$t('TABLES.delivary_name')"
                v-model="filterOptions.delivery"
              />

              <base-input
                col="3"
                type="text"
                :placeholder="$t('PLACEHOLDERS.shop_name')"
                v-model="filterOptions.store_name"
              />
              <!-- Start:: Start Date Input -->
              <base-picker-input
                col="3"
                type="date"
                :placeholder="$t('PLACEHOLDERS.startDate')"
                v-model.trim="filterOptions.from_date"
              />
              <!-- End:: Start Date Input -->

              <!-- Start:: End Date Input -->
              <base-picker-input
                col="3"
                type="date"
                :placeholder="$t('PLACEHOLDERS.endDate')"
                v-model.trim="filterOptions.to_date"
              />
              <!-- End:: End Date Input -->
            </div>

            <div class="btns_wrapper">
              <button class="submit_btn" :disabled="isWaitingRequest">
                <i class="fal fa-search"></i>
              </button>
              <button
                class="reset_btn"
                type="button"
                :disabled="isWaitingRequest"
                @click="resetFilter"
              >
                <i class="fal fa-redo"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <!--  =========== End:: Filter Form =========== -->

      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>
            {{ $t("PLACEHOLDERS.unfinished_orders") }}
          </h5>
          <button
            v-if="!filterFormIsActive"
            class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive"
          >
            <i class="fal fa-search"></i>
          </button>
        </div>

        <div class="title_route_wrapper">
          <!-- <div class="excel" @click="downloadExcel">
            {{ $t("BUTTONS.downloadExcel") }}
          </div> -->

          <base-button
            class="mt-0 pdf_btn"
            styleType="solid_btn"
            :btnText="$t('BUTTONS.downloadPdf')"
            @fireClick="downloadPdf"
            :disabled="pdfDownloadBtnIsLoading"
          >
            <template v-slot:btn_icon>
              <i class="fal fa-file-pdf"></i>
            </template>
          </base-button>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        :items-per-page="paginations.items_per_page"
        @click:row="rowClicked"
        hide-default-footer
      >
        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <!-- Start:: No Data State -->

        <template v-slot:[`item.order_id`]="{ item, index }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item.order_id">
              {{ $t("TABLES.noData") }}
            </h6>
            <p v-else>
              {{
                (paginations.current_page - 1) * paginations.items_per_page +
                index +
                1
              }}
            </p>
          </div>
        </template>

        <template v-slot:[`item.delivery_name`]="{ item }">
          <p
            class="blue-grey--text text--darken-1 fs-3"
            v-if="item.delivery_name == ''"
          >
            -
          </p>
          <p v-else>
            {{ item.delivery_name }}
          </p>
        </template>
        <template v-slot:[`item.provider_profit`]="{ item }">
          <p>
            {{ item.orderBudget.service_provider_profit }}
          </p>
        </template>
        <template v-slot:[`item.delivery_profit`]="{ item }">
          <p>
            {{ item.orderBudget.delivery_net_profit }}
          </p>
        </template>
        <template v-slot:[`item.tax`]="{ item }">
          <p>
            {{ item.orderBudget.tax }}
          </p>
        </template>
        <template v-slot:[`item.app_profit`]="{ item }">
          <p>
            {{
              item.orderBudget.profit_from_delivety +
              item.orderBudget.profit_from_provider
            }}
          </p>
        </template>
        <template v-slot:[`item.total`]="{ item }">
          <p>
            {{ item.orderBudget.total }}
          </p>
        </template>

        <!-- <template v-slot:[`item.count`]="{ item }">
          <router-link
            :to="{
              path: `/orders/all`,
              query: {
                page: 1,
                providerId: item.id,
                is_finished: 1,
              },
            }"
          >
            {{ item.count }}
          </router-link>
        </template> -->

        <!-- Start:: Actions -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="actions">
            <!--  v-if="permissions.show" -->
            <a-tooltip placement="bottom">
              <template slot="title">
                <span>{{ $t("BUTTONS.show") }}</span>
              </template>
              <button class="btn_show" @click="showItem(item)">
                <i class="fal fa-eye"></i>
              </button>
            </a-tooltip>
          </div>
        </template>
        <!-- End:: Actions -->

        <!-- ======================== Start:: Dialogs ======================== -->
        <template v-slot:top>
          <!-- Start:: pdf Modal -->
          <!-- <v-dialog v-model="dialogPdf">
            <v-card>
              <button class="ex-btn-s" @click="clickedDownload"> {{ $t("PLACEHOLDERS.export_pdf") }}</button>

              <v-card-actions>
                <v-btn class="modal_cancel_btn" @click="dialogPdf = false">{{ $t("BUTTONS.cancel") }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog> -->
          <!-- End:: pdf Modal -->

          <!-- Start:: excel Modal -->
          <!-- <v-dialog v-model="dialogExcel">
            <v-card>
              <a class="ex-btn-s" :href="excel" download>
                {{ $t("PLACEHOLDERS.export_excel") }}
              </a>
              <v-card-actions>
                <v-btn class="modal_cancel_btn" @click="dialogExcel = false">{{ $t("BUTTONS.cancel") }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog> -->
          <!-- End:: excel Modal -->
        </template>
        <!-- ======================== End:: Dialogs ======================== -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
      <!-- ==== Start:: Overall_statistics Addresses ==== -->
      <div class="table_content">
        <div class="table_title_wrapper">
          <div class="title_text_wrapper">
            <!-- <h5>{{ $t("PLACEHOLDERS.Overall_statistics") }}</h5> -->
          </div>
        </div>
        <v-simple-table class="stat-table">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center">
                  {{ $t("PLACEHOLDERS.total_provider_profit") }}
                </th>
                <th class="text-center">
                  {{ $t("PLACEHOLDERS.total__delivery_profit") }}
                </th>
                <th class="text-center">
                  {{ $t("PLACEHOLDERS.totalTaxValue") }}
                </th>
                <th class="text-center">
                  {{ $t("PLACEHOLDERS.total_admin_profit") }}
                </th>
                <th class="text-center">
                  {{ $t("PLACEHOLDERS.total_completed_orders") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template>
                <tr class="text-center all-stat">
                  <td>{{ service_provider_profit }}</td>
                  <td>{{ service_delivery_profit }}</td>
                  <td>{{ tax }}</td>
                  <td>{{ total_management_profit }}</td>
                  <td>{{ total }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <!-- ==== End:: Overall_statistics Addresses ==== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </template>
    <!-- End:: Pagination -->

    <!-- Start:: Generate PDF Template Content -->
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :filename="$t('PLACEHOLDERS.unfinished_orders')"
      :pdf-quality="2"
      pdf-format="a4"
      :manual-pagination="false"
      :paginate-elements-by-height="1400"
      pdf-content-width="100%"
      @progress="bdfDownloadBtnIsLoading = true"
      @hasGenerated="$message.success($t('MESSAGES.generatedSuccessfully'))"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="pdf_file_content">
          <h3 class="file_title">
            {{ $t("PLACEHOLDERS.unfinished_orders") }}
          </h3>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <template v-for="(header, index) in tableHeaders">
                    <th :key="header.value" v-if="index !== 0">
                      <span>{{ header.text }}</span>
                    </th>
                  </template>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in tableRows" :key="row.id">
                  <td v-if="index !== 0">
                    {{ row.order_number ? row.order_number : "-" }}
                  </td>
                  <td v-if="index !== 0">
                    {{ row.user_name ? row.user_name : "-" }}
                  </td>
                  <td v-if="index !== 0">
                    {{ row.provider_name ? row.provider_name : "-" }}
                  </td>
                  <td v-if="index !== 0">
                    {{ row.delivery_name ? row.delivery_name : "-" }}
                  </td>
                  <td v-if="index !== 0">
                    {{
                      row?.orderBudget?.service_provider_profit
                        ? row.orderBudget?.service_provider_profit
                        : "-"
                    }}
                  </td>
                  <td v-if="index !== 0">
                    {{
                      row?.orderBudget?.delivery_net_profit
                        ? row.orderBudget?.delivery_net_profit
                        : "-"
                    }}
                  </td>
                  <td v-if="index !== 0">
                    {{ row?.orderBudget?.tax ? row.orderBudget?.tax : "-" }}
                  </td>
                  <td v-if="index !== 0">
                    {{
                      row?.orderBudget?.profit_from_delivety &&
                      row?.orderBudget?.profit_from_provider
                        ? row.orderBudget.profit_from_delivety +
                          row.orderBudget.profit_from_provider
                        : "-"
                    }}
                  </td>
                  <td v-if="index !== 0">
                    {{ row?.orderBudget?.total ? row.orderBudget?.total : "-" }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <!-- ==== Start:: Overall_statistics Addresses ==== -->

          <div class="table_content">
            <div class="table_title_wrapper">
              <div class="title_text_wrapper">
                <!-- <h5>{{ $t("PLACEHOLDERS.Overall_statistics") }}</h5> -->
              </div>
            </div>
            <v-simple-table class="stat-table mt-5">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">
                      {{ $t("PLACEHOLDERS.total_provider_profit") }}
                    </th>
                    <th class="text-center">
                      {{ $t("PLACEHOLDERS.total__delivery_profit") }}
                    </th>
                    <th class="text-center">
                      {{ $t("PLACEHOLDERS.totalTaxValue") }}
                    </th>
                    <th class="text-center">
                      {{ $t("PLACEHOLDERS.total_admin_profit") }}
                    </th>
                    <th class="text-center">
                      {{ $t("PLACEHOLDERS.total_completed_orders") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template>
                    <tr class="text-center all-stat">
                      <td>{{ service_provider_profit }}</td>
                      <td>{{ service_delivery_profit }}</td>
                      <td>{{ tax }}</td>
                      <td>{{ total_management_profit }}</td>
                      <td>{{ total }}</td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <!-- ==== End:: Overall_statistics Addresses ==== -->
        </div>
      </section>
    </vue-html2pdf>
    <!-- End:: Generate PDF Template Content -->
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
import { mapGetters } from "vuex";

export default {
  name: "AllFinancialReports",

  components: {
    VueHtml2pdf,
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),

    UserTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.designer_filter"),
          value: "designer",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.service_requester"),
          value: "client",
        },
      ];
    },
  },

  data() {
    return {
      service_provider_profit: 0,
      service_delivery_profit: 0,
      tax: 0,
      total_management_profit: 0,
      total: 0,
      statistic: {
        count: null,
        providerRevenu: null,
        appRevenu: null,
        totalVat: null,
      },

      // Start:: Loading Data
      loading: false,
      isWaitingRequest: false,
      pdfDownloadBtnIsLoading: false,
      excelDownloadBtnIsLoading: false,
      // End:: Loading Data

      // Start:: Filter Data
      filterFormIsActive: false,
      filterOptions: {
        provider_name: null,
        client_name: null,
        user_phone_number: null,
        from_date: null,
        to_date: null,
        user: "",
        provider: "",
        store_name: "",
      },
      allproviders: [],
      // End:: Filter Data

      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.Admins.serialNumber"),
          value: "order_id",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.orderNum"),
          value: "order_number",
          sortable: false,
          align: "center",
        },

        {
          text: this.$t("PLACEHOLDERS.clientName"),
          value: "user_name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.name_admin"),
          value: "provider_name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("TABLES.delivary_name"),
          value: "delivery_name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.service_provider_profit"),
          value: "provider_profit",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.net_profit_from_delivery_agent"),
          value: "delivery_profit",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.tax_value"),
          value: "tax",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.admin_profit"),
          value: "app_profit",
          sortable: false,
          align: "center",
        },

        {
          text: this.$t("PLACEHOLDERS.total_order_value"),
          value: "total",
          sortable: false,
          align: "center",
        },
      ],
      tableRows: [],
      // End:: Table Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 10,
      },
      // End:: Pagination Data
      // Start:: Dialogs Control Data
      dialogImage: false,
      selectedItemImage: null,
      dialogDescription: false,
      selectedDescriptionTextToShow: "",
      dialogPdf: false,
      itemToPdf: null,
      dialogExcel: false,
      itemToExcel: null,

      permissions: null,
      total_provider_profit: null,
      totalTaxValue: null,
      total_admin_profit: null,
      total_orders_duration: null,
      total_orders_with_tax: null,

      pdf: null,
      excel_report: null,
    };
  },

  watch: {
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
  },

  methods: {
    async submitFilterForm() {
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/financial-reports/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },
    async resetFilter() {
      this.filterOptions.provider_name = null;
      this.filterOptions.provider = null;
      this.filterOptions.store_name = null;
      this.filterOptions.delivery = null;

      this.filterOptions.user = null;
      this.filterOptions.from_date = null;
      this.filterOptions.to_date = null;
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/financial-reports/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },
    rowClicked(e, item) {
      console.log(item.item.order_id);
      this.$router.push({
        path: `/orders/show/${item.item.order_id}`,
      });
    },
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    async setTableRows() {
      this.loading = true;

      try {
        let res = await this.$axios({
          method: "GET",
          url: "invoices",
          params: {
            status: "not_finish",
            page: this.paginations.current_page,
            providerName: this?.filterOptions?.provider_name,
            user: this.filterOptions.user,
            provider: this.filterOptions.provider,
            store_name: this?.filterOptions?.store_name,
            delivery: this?.filterOptions?.delivery,
            created_at: [
              this?.filterOptions?.from_date ?? "",
              this?.filterOptions?.to_date ?? "",
            ],
          },
        });
        this.loading = false;
        this.loading = false;
        this.tableRows = res.data.data.invoices.data;

        this.service_provider_profit =
          res.data.data.totals.service_provider_profit.toFixed(2);
        this.service_delivery_profit =
          res.data.data.totals.service_delivery_profit.toFixed(2);
        this.tax = res.data.data.totals.tax.toFixed(2);
        this.total_management_profit =
          res.data.data.totals.total_management_profit.toFixed(2);
        this.total = res.data.data.totals.total.toFixed(2);
        this.paginations.last_page = res.data.data.invoices.meta.last_page;
        this.paginations.items_per_page = res.data.data.invoices.meta.per_page;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // End:: Set Table Rows

    // Start:: Handling Download Files
    async downloadPdf() {
      await this.$refs.html2Pdf.generatePdf();
      this.pdfDownloadBtnIsLoading = false;
    },

    async downloadExcel() {
      window.open(this.excel_report, "_blank");
    },
    // End:: Handling Download Files

    // ==================== Start:: Crud ====================
    // ===== Start:: Show
    showItem(item) {
      // this.$router.push({ path: `/orders/show/${item.id}` });
      // this.$router.push({ path: `/orders/all`, query: { provider: item.user_applicant } });
    },
    // ===== End:: Show

    // ==================== End:: Crud ====================
  },

  created() {
    // Start:: Fire Methods
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }

    this.setTableRows();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
.ex-btn-s {
  color: black !important;
  font-size: 20px;
  font-weight: bold;
  text-decoration: underline !important;
}

.all-stat {
  background: var(--main_theme_clr);
}

.all-stat td {
  color: white;
  font-size: 21px !important;
  font-weight: 800;
}

.show_all_content_wrapper
  .v-data-table
  .v-data-table__wrapper
  table
  tbody
  tr:hover {
  background: var(--main_theme_clr) !important;
}

.excel {
  background: darkgreen;
  padding: 7px 10px;
  border-radius: 12px;
  color: #fff;
  cursor: pointer;
}
</style>
